var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanSmokingLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85071CD9-04C1-490E-9016-3B9F46AE6803") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-1",
    transform: "translate(-223.000000, -1824.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(222.000000, 1729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ban-smoking-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7734375,8.5390625 L15.734375,17.5 L18.234375,20 L20.734375,22.5 L23.234375,25 L31.4609375,33.2265625 C28.390625,35.890625 24.3828125,37.5 20,37.5 C10.3359375,37.5 2.5,29.6640625 2.5,20 C2.5,15.6171875 4.109375,11.609375 6.7734375,8.5390625 Z M21.765625,20 L30,20 L30,22.5 L24.265625,22.5 L21.765625,20 Z M26.765625,25 L31.25,25 C31.9375,25 32.5,24.4375 32.5,23.75 L32.5,18.75 C32.5,18.0625 31.9375,17.5 31.25,17.5 L19.265625,17.5 L8.5390625,6.7734375 C11.609375,4.109375 15.6171875,2.5 20,2.5 C29.6640625,2.5 37.5,10.3359375 37.5,20 C37.5,24.3828125 35.890625,28.390625 33.2265625,31.4609375 L26.765625,25 Z M20,40 C31.045695,40 40,31.045695 40,20 C40,8.954305 31.045695,0 20,0 C8.954305,0 0,8.954305 0,20 C0,31.045695 8.954305,40 20,40 Z M21.25,7.5 C20.5625,7.5 20,8.0625 20,8.75 C20,10.8203125 21.6796875,12.5 23.75,12.5 L26.25,12.5 C26.9375,12.5 27.5,13.0625 27.5,13.75 C27.5,14.4375 28.0625,15 28.75,15 C29.4375,15 30,14.4375 30,13.75 C30,11.6796875 28.3203125,10 26.25,10 L23.75,10 C23.0625,10 22.5,9.4375 22.5,8.75 C22.5,8.0625 21.9375,7.5 21.25,7.5 Z M17.1953125,22.5 L10,22.5 L10,20 L14.6953125,20 L12.1953125,17.5 L8.75,17.5 C8.0625,17.5 7.5,18.0625 7.5,18.75 L7.5,23.75 C7.5,24.4375 8.0625,25 8.75,25 L19.6953125,25 L17.1953125,22.5 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanSmokingLight);
export default __webpack_public_path__ + "static/media/ban-smoking-light.4ceaf6345a20574c868a1b155c2546d8.svg";
export { ForwardRef as ReactComponent };